import { render, staticRenderFns } from "./CharacterSheetCastingAddPower.vue?vue&type=template&id=23c4c22c&lang=pug&"
import script from "./CharacterSheetCastingAddPower.vue?vue&type=script&lang=ts&"
export * from "./CharacterSheetCastingAddPower.vue?vue&type=script&lang=ts&"
import style0 from "./CharacterSheetCastingAddPower.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VIcon,VSpacer})
